import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { bmamreportdelete, bmamreportlist } from "../../../services/bmam";
import { PURPOSES, STATUSES } from "./addbmamreport";

/** Bootstrap badge colour per visit status. */
const STATUSBADGE = {
    very_good: "badge bg-success",
    good: "badge bg-primary",
    bad: "badge bg-danger",
};

export function purposelabel(value) {
    const found = PURPOSES.find((item) => item.value === value);
    return found ? found.label : value;
}

export function statuslabel(value) {
    const found = STATUSES.find((item) => item.value === value);
    return found ? found.label : value;
}

export default function AllBmamReport() {
    const navigate = useNavigate();
    const [filterProduct, setFilterProduct] = useState([]);

    const [rdate, setRDate] = useState("");
    const [otype, setOType] = useState("");
    const [purpose, setPurpose] = useState("");
    const [status, setStatus] = useState("");

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 130,
            sortable: false,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => navigate(`/bmam/reportdetail/${params.value}`)}
                            className="btn-sm btn-info me-2"
                            title="Report Detail"
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                        <a
                            onClick={() => handleDelete(params.value)}
                            className="btn-sm btn-danger me-2"
                            title="Delete Report"
                        >
                            <i className="fa fa-trash"></i>
                        </a>
                    </div>
                );
            },
        },
        {
            headerName: "Date",
            field: "report_date",
            width: 130,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return params.value !== null ? moment(params.value).format("DD-MM-YYYY") : "";
            },
        },
        {
            headerName: "BM / AM",
            field: "officer_type",
            width: 110,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Name",
            field: "staff_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Center Name",
            field: "group_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return params.data.all_centers ? "All Center's View" : params.value;
            },
        },
        {
            headerName: "Purpose of Visit",
            field: "purpose",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return purposelabel(params.value);
            },
        },
        {
            headerName: "Status",
            field: "status",
            width: 130,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <span className={STATUSBADGE[params.value] || "badge bg-secondary"}>
                        {statuslabel(params.value)}
                    </span>
                );
            },
        },
        {
            headerName: "Reports",
            field: "report",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Remark",
            field: "remark",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "BM Signature",
            field: "bm_signature",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];

    useEffect(() => {
        funlist();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function funlist(filters = {}) {
        setFilterProduct([]);
        const temp = new FormData();
        temp.append("branch_id", localStorage.getItem("branch"));
        temp.append("report_date", filters.report_date || "");
        temp.append("officer_type", filters.officer_type || "");
        temp.append("purpose", filters.purpose || "");
        temp.append("status", filters.status || "");

        bmamreportlist(temp).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data.details);
            }
        });
    }

    function handlefilter(e) {
        e.preventDefault();
        funlist({
            report_date: rdate,
            officer_type: otype,
            purpose: purpose,
            status: status,
        });
    }

    function handlereset() {
        setRDate("");
        setOType("");
        setPurpose("");
        setStatus("");
        funlist();
    }

    function handleDelete(lid) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                bmamreportdelete(lid).then((response) => {
                    if (response.status === true) {
                        funlist();
                    }
                });
            }
        });
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">BM &amp; AM Daily Reports</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>BM &amp; AM Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        All Reports
                    </li>
                </ol>
            </div>

            <div className="d-flex justify-content-end">
                <a className="btn btn-success" onClick={() => navigate("/bmam/addreport")}>
                    Add Report
                </a>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={rdate}
                                                onChange={(e) => setRDate(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">BM / AM</label>
                                            <select
                                                className="default-select form-control wide"
                                                value={otype}
                                                onChange={(e) => setOType(e.target.value)}
                                            >
                                                <option value="">All</option>
                                                <option value="BM">BM</option>
                                                <option value="AM">AM</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Purpose of Visit</label>
                                            <select
                                                className="default-select form-control wide"
                                                value={purpose}
                                                onChange={(e) => setPurpose(e.target.value)}
                                            >
                                                <option value="">All</option>
                                                {PURPOSES.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6">
                                        <div className="mb-3">
                                            <label className="form-label">Status</label>
                                            <select
                                                className="default-select form-control wide"
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                            >
                                                <option value="">All</option>
                                                {STATUSES.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-end">
                                    <a className="btn btn-secondary me-2" onClick={handlereset}>
                                        Reset
                                    </a>
                                    <a className="btn btn-primary" onClick={handlefilter}>
                                        Search
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    BM &amp; AM Daily Report List
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={filterProduct}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
